import React, { memo } from 'react';
import { SidebarBoundary } from '@atlassian/jira-navigation-apps-sidebar-common/src/async.tsx';
import {
	setPerformanceMarkLoadStart,
	setPerformanceMarkLoadEnd,
} from '@atlassian/jira-navigation-apps-sidebar-common/src/utils/performance-marks/index.tsx';
import { lazyAfterPaint } from '@atlassian/react-loosely-lazy';
import type { GlobalSettingsIssuesSidebar as GlobalIssuesSettingsSidebarType } from './ui/index.tsx';

const LazyGlobalIssuesSettingsSidebar = lazyAfterPaint<typeof GlobalIssuesSettingsSidebarType>(
	() => {
		setPerformanceMarkLoadStart();
		return import(/* webpackChunkName: "async-sidebar-global-settings-issues" */ './index').then(
			(bundle) => {
				setPerformanceMarkLoadEnd();
				return bundle;
			},
		);
	},
);

const GlobalIssuesSettingsSidebar = memo(() => (
	<SidebarBoundary id="globalIssuesSettings">
		<LazyGlobalIssuesSettingsSidebar />
	</SidebarBoundary>
));

export default GlobalIssuesSettingsSidebar;
